import { OutputData } from "@editorjs/editorjs";
import {
  arrayOfStrSchema,
  imageSchema,
  numberSchema,
  stringSchema,
} from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  title: "title",
  shortDescription: "shortDescription",
  slug: "slug",
  banner: "banner",
  content: "content",
  listOrderNumber: "listOrderNumber",
  language: "language",
  author: "author",
  categoryIds: "categoryIds",
} as const;

export const validation = (URL_ID: string | undefined, t: TFunction) => {
  return yup.object().shape({
    [fieldNames.title]: stringSchema(fieldNames.title, t),
    [fieldNames.shortDescription]: stringSchema(fieldNames.shortDescription, t),
    [fieldNames.slug]: stringSchema(fieldNames.slug, t),
    [fieldNames.banner]: imageSchema(fieldNames.banner, t),
    [fieldNames.content]: yup
      .mixed<OutputData>()
      .required(t("required", { field: fieldNames.content })),
    [fieldNames.listOrderNumber]: numberSchema(fieldNames.listOrderNumber, t),
    [fieldNames.language]: yup
  .mixed<any>()
  .transform((value) => {
    if (Array.isArray(value)) return value[0]?.value;
    if (typeof value === "object" && value !== null) return value.value;
    return value;
  })
  .required(t("pleaseEnter", { changeablePart: t(fieldNames.language) }))
  .typeError(t("pleaseEnter", { changeablePart: t(fieldNames.language) }))
  .label(t(fieldNames.language)),

    [fieldNames.author]: stringSchema(fieldNames.author, t),
    [fieldNames.categoryIds]: arrayOfStrSchema(fieldNames.categoryIds, t),})

};
